export default __webpack_public_path__ + "static/hyper-599b6d3e6859798d4ef88ee09ed46d69.png";